import { QueryClientStore } from '../query-client.store';
import { ContainerBuilder } from '../../test/mock-adapters/container-builder';

export const testApi = {
    fetchJobs: (teamId?: number): Promise<string[]> =>
        Promise.resolve(teamId ? [`job-${teamId}-1`, `job-${teamId}-2`] : ['job-1', 'job-2']),
    fetchTechs: (): Promise<string[]> => Promise.resolve(['tech-1', 'tech-2']),
    deleteJob: (_id: number): Promise<void> => Promise.resolve(),
};

export function buildStore<T>(storeClass: new (...args: any[]) => T) {
    const builder = new ContainerBuilder().add(storeClass).build();
    const store = builder.container.get(storeClass) as T & {
        initialize(): void;
        dispose(): void;
    };
    const clientStore = builder.container.get(QueryClientStore);
    return { store, clientStore, initialize: builder.initialize };
}
